<template>
  <v-tooltip right>

    <template #activator="{ on }">
      <div class="text-box" v-on="on">
        <v-icon>mdi-information-outline</v-icon>
        <p class="text">Replaceable</p>
      </div>
    </template>

    <v-alert text color="primary" border="right" colored-border type="info">
      <div class="block">
          {{ $t('keywords.replace.paragraph.use_between') }}
          <code>#</code>
          {{ $t('keywords.replace.paragraph.the_properties') }}
      </div>
      <div class="block"> {{ $t('keywords.replace.paragraph.is_possible') }}
        (<code>headers</code>), {{ $t('keywords.replace.paragraph.body_param') }}
        (<code>body</code>) {{ $t('keywords.replace.paragraph.url_param') }} (<code>params</code>)
      </div>
      <div class="block"> {{ $t('keywords.replace.paragraph.example') }} : </div>
      <div class="block">
        <div class="msg" v-if="urlParameter">{{ $t('keywords.replace.code_label.url_param') }} : <code>&lt;{{ $t('keywords.replace.code.url_param.worker') }}&gt;#params.{{ $t('keywords.replace.code.url_param.some_param') }}#&lt;/{{ $t('keywords.replace.code.url_param.worker') }}&gt;</code></div>
        <div class="msg" v-if="bodyProperty">{{ $t('keywords.replace.code_label.body_prop') }} :<code>"{{ $t('keywords.replace.code.body_prop.company') }}": "#body.{{ $t('keywords.replace.code.body_prop.some_prop') }}#"</code></div>
        <div class="msg" v-if="actionProperty">{{ $t('keywords.replace.code_label.action_prop') }} : <code>#{{ $t('keywords.replace.code.action_name') }}.{{ $t('keywords.replace.code.action_prop') }}#</code></div>
        <div class="msg" v-if="actionValue">{{ $t('keywords.replace.code_label.action_value') }} : <code>#{{ $t('keywords.replace.code.action_name') }}#</code></div>
        <div class="msg" v-if="lastReturn">{{ $t('keywords.replace.code_label.last_action_value') }} : <code>#lastReturn#</code></div>
        <div class="msg" v-if="forValue">{{ $t('keywords.replace.code_label.for.value') }} :  <code>#{{ $t('keywords.replace.code.for.value') }}#</code></div>
        <div class="msg" v-if="forMapKey">{{ $t('keywords.replace.code_label.for.key') }} : <code>#{{ $t('keywords.replace.code.for.key') }}_key#</code></div>
        <div class="msg" v-if="forIndex">{{ $t('keywords.replace.code_label.for.index') }} : <code>#{{ $t('keywords.replace.code.for.value') }}_index#</code></div>
        <div class="msg" v-if="webServiceStatus">{{ $t('keywords.replace.code_label.web_service_status') }} :  <code>#{{ $t('keywords.replace.code.action_name') }}_statusCode#</code></div>
        <div class="msg" v-if="jsonProperty">{{ $t('keywords.replace.code_label.json_prop') }} : <code>&lt;{{ $t('keywords.replace.code.url_param.worker') }}&gt;#{{ $t('keywords.replace.code.body_prop.some_prop') }}#&lt;/{{ $t('keywords.replace.code.url_param.worker') }}&gt;</code></div>
      </div>
    </v-alert>

  </v-tooltip>
</template>

<script>
export default {
  name: 'ReplaceInfo',

  props: {
    urlParameter: Boolean,
    bodyProperty: Boolean,
    actionProperty: Boolean,
    actionValue: Boolean,
    lastReturn: Boolean,
    forValue: Boolean,
    forMapKey: Boolean,
    forIndex: Boolean,
    webServiceStatus: Boolean,
    jsonProperty: Boolean
  }

}
</script>

<style scoped>
.v-tooltip__content {
  background: transparent;
  opacity: 1;
}
.v-alert {
  background-color: #FFFFFF !important;
}
.text-box {
  display: inline;
  padding: .3em;
}
.text {
  margin: auto 0;
  font-weight: bold;
  color: #009280;
  display: inline;
}
code {
  height: auto;
  padding: .2em .4em;
  margin: auto 0;
}
.msg>code{
  margin-left: 8px;
}
.block {
  margin: 0;
  padding: 0;
}
.msg {
  display: flex;
  text-align: middle;
  margin: 4px;
}
</style>
